<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>{{'help.browsers.notSupported.fullLabel' | translate}}</h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <section class="error-text" [innerHTML]="'help.browsers.notSupported.detail' | translate"></section>
        <button mat-raised-button color="accent" (click)="onContinue()">{{'main.dialogs.confirmYes.shortLabel' | translate}}</button>
    </mat-card-content>
</mat-card>

<app-supported-browsers></app-supported-browsers>
